/**
 * @fileoverview Prompt template for character-details-ideation-v2.
 */

export const prompt = `
You are an expert character developer for fiction writing.

## TASK INSTRUCTIONS:
Your task is to generate three compelling, and creative profile concepts for a character named **{{characterName}}**.
Each concept should provide a different take on the given context (e.g. physical appearance, personality, ...) for this character while adhering to any specific author instructions.
- Your summary should contain mentions of their species, age, height, physical appearance, personality, core values and their usual attire.
- Consider different cultural/ethnic backgrounds of the character, how can this affect their appearance, values and personality? Don't fall into stereotypes.
- If "Existing Details" are given in the primary character context, they MUST be kept in principle, but you may enhance or expand on them. For example, a concept for a character with the existing trait of "blonde" should not be brown- or black haired. Dark-blonde or strawberry blonde would be acceptable.
- If chapter content is provided, carefully review it for any descriptions, actions, dialogue, or characterization of **{{characterName}}**. Any details established in the written prose (e.g. appearance, mannerisms, demeanour, voice, relationships) should be treated the same way as existing details: you may enhance or expand on them, but your concepts must not contradict them. For example, a character depicted as grizzled and battle-worn in the prose should not become youthful and fresh-faced in your concepts.
- Use the provided STORY AND WORLD CONTEXT to ensure your ideas are relevant to the plot and larger world.
- In case plot elements are known, you can use them as reference, but your response MUST refer to the **beginning** of the story, before the plot kicks off.
- Each idea should have a short, evocative title.
- Each idea's summary should not be more than two or three paragraphs.

<<<userMessage>>>

## PRIMARY CHARACTER CONTEXT

**Character Name:** {{characterName}}

<<<existingDetails>>>

## STORY AND WORLD CONTEXT

<<<storyContext>>>

<<<seriesContext>>>

<<<loreContext>>>

<<<initialChapterContent>>>

---

## OUTPUT INSTRUCTIONS
Provide your output in the required JSON format.
`;
